/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @import { VirtualKeyboardInfo } from '.'
 */

/**
 * Informace o skryté virtuální klávesnici.
 * @implements {VirtualKeyboardInfo}
 */
export default class VirtualKeyboardHidden {
  /** @type {VirtualKeyboardInfo['getHeight']} */
  getHeight() {
    return '0';
  }

  /** @type {VirtualKeyboardInfo['isDisplayed']} */
  isDisplayed() {
    return false;
  }

  /** @type {VirtualKeyboardInfo['isOverlapping']} */
  isOverlapping() {
    return false;
  }
}
